import React, { createContext, useState, useContext } from 'react';
import Login from '../components/Login';
import Register from '../components/Register';

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [modalView, setModalView] = useState(null);

  const closeModal = () => {
    setModalView(null);
  };

  const showLogin = () => {
    setModalView('login');
  };

  const showRegister = () => {
    setModalView('register');
  };

  let modalContent = null;
  if (modalView === 'login') {
    modalContent = <Login onClose={closeModal} key="login" />;
  } else if (modalView === 'register') {
    modalContent = <Register onClose={closeModal} key="register" />;
  }

  return (
    <ModalContext.Provider value={{ 
      isOpen: modalView !== null, 
      modalContent, 
      closeModal, 
      showLogin, 
      showRegister 
    }}>
      {children}
    </ModalContext.Provider>
  );
}; 